/** ########  socket配置文件 该js文件不处理业务逻辑  ###########**/
import baseConfig from '../../../config'
import FaceObjConfig from '@/assets/data/faceObjConfig.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'

export default {
  data () {
    return {
      messageData: {},
      noSendMessageObj: {}
    }
  },
  computed: {
    ...mapState({
      visitorInfo: 'visitorInfo',
      service: 'service',
      feedBackConfig: 'feedBackConfig',
      channelGroupVoList: 'channelGroupVoList',
      isEndChat: 'isEndChat',
      referenceMessageObj: 'referenceMessageObj'
    }),
    ...mapGetters({
      serviceId: 'serviceId',
      groupStatus: 'groupStatus',
      agentId: 'agentId'
    })
  },
  methods:{
    ...mapMutations({
      updateGroupUnreadyNum: 'updateGroupUnreadyNum',
      set_isCusServiceInput: 'set_isCusServiceInput',
      set_channelGroupVoList: 'set_channelGroupVoList'
    }),
    bindSocketLink() {
      let http = process.env.NODE_ENV == 'development' ?  baseConfig.proxy_ip : location.origin
      let url = http + `/visit`;
      let vis = this.$store.state.visitorInfo;
      let query = {
        visitorId: vis.visitorId
      };
      this.$root.socket = window.io(url,{
        query: query,
        multiplex: false,
        transports: ['websocket']
      })
    },
    // 定义socket事件
    initSocketEvent (resolve) {
      this.$root.socket.on('connect',  (res)=> {
        // 连接成功
        if (resolve) {
          resolve()
        }
        // 获取离线消息
        this.getOffLineMessage()
      })
      this.$root.socket.on('message',  (res)=> {
        if (res.display === 'all' || res.display === 'visitor' || res.destination === 'all' || res.destination === 'VISITOR') {
          // 接收消息
          this.$bus.$emit('socket.message', res)
          if (res.groupId !== this.$store.state.currentGroup.groupId) {
            if (res.belong === 'agent' || res.belong === 'system') {
              this.updateGroupUnreadyNum(res.groupId)
            }
          }
        }
      })
      this.$root.socket.on('leaveThank',  (res)=> {
        // 留言感谢语
        this.$bus.$emit('socket.message', {type: 3, content: res.content})
      })
      this.$root.socket.on('joinRoom',  ()=> {

      })
      this.$root.socket.on('groupUpgrade',  (res)=> {
        this.set_service(res.service)
        this.visitorInfo.groupId = res.service.groupId
      })
      this.$root.socket.on('changeGroupOwner',  (res)=> {
        this.set_service(res.service)
        this.visitorInfo.groupId = res.service.groupId
      })
      // 撤回消息
      this.$root.socket.on('revoke',  (res)=> {
        this.$bus.$emit('socket.revokeMessage',res)
      })
      this.$root.socket.on('revokeMessage',  (res)=> {
        // 消息撤回
        this.$bus.$emit('socket.revokeMessage',res)
      })
      this.$root.socket.on('evaluate',  (res)=> {
        // 主动邀请评价
        if (this.feedBackConfig.isOpen ) {
          this.inviteEvaluation(res)
        }
      })
      this.$root.socket.on('joinQueue', (res)=> {
        // 排队
        this.visitorQueue(res)
      })
      this.$root.socket.on('cusServiceInput', (res) => {
        this.set_isCusServiceInput({
          groupId: res.groupId + '',
          content: res
        })
      })
      // 分配客服成功触发
      this.$root.socket.on('visitorJoin',  (res) => {
        // const visitorId = this.visitorInfo.visitorId || localStorage.getItem('visitorId')
        // const params = {
        //   visitorId: visitorId || '',
        //   serviceId: this.visitorInfo.serviceId || '',
        //   tenantId: this.visitorInfo.tenantId || '',
        //   agentId: this.visitorInfo.agentId || '',
        // }
        this.$store.commit('set_visitorStatus', true)
        res.visitStatus = '1'
        // 这个事件触发一定是在线
        // this.visitorJoin(res.serviceId)
        this.set_service(res.service)
        this.set_currentGroup({
          groupId: res.groupId || res.service.groupId, // 技能组id
          groupName: res.groupName || res.service.groupName, // 渠道名称
          visitStatus: res.visitStatus, // 访客在该技能组的状态
          unreadMsgCount: res.unreadMsgCount, // 未读消息数量
        })
      })
      this.$root.socket.on('finish', (res) => {
        this.onlyUpdateGroupStatus({groupId: res.service.groupId, status: '3'})
        this.$store.commit('set_visitorStatus', false)
        this.$bus.$emit('endChat')
      })
      this.$root.socket.on('agentRead', (res) => {
        this.$bus.$emit('socket.agentRead', res)
      })
      // 转接 forward
      this.$root.socket.on('forward', (res) => {
        // this.$bus.$emit('forward')
        res.visitStatus = '1'
        this.visitorJoin(res)
      })
      // 接收技能组
      this.$root.socket.on('groupList', (res) => {
        console.log(res, '技能组消息')
        // this.set_channelGroupVoList(res.groupList)
      })
    },
    getOffLineMessage () {
      const visitorId = this.visitorInfo.visitorId || localStorage.getItem('newVisitorId')
      const params = {
        visitorId: visitorId
      }
      ajax.get(apis.chat.findMessages, { params }).then((res) => {
        console.log(res, '离线数据')
        ;(res.data || []).map(messageItem => {
          this.$bus.$emit('socket.message', {
            belong: 'visitor',
            ...messageItem
          })
        })
        this.$bus.$emit('socket.message', { channelGroupVoList: this.channelGroupVoList })
      })
    },
    clearNoRead (visitorId) { // 已读
      this.$root.socket.emit('read', this.visitorInfo.tenantId, this.visitorInfo.agentId, this.visitorInfo.visitorId, (res) => {
        // this.clear_read(visitorId)
      })
    },
    // 初始化socket
    init_socket () {
      return new Promise((resolve, reject) => {
        this.bindSocketLink()
        this.initSocketEvent(resolve)
      })
    },
    socketMessageEd (sendMessage) {
      // 判断是否存在消息引用
      if(JSON.stringify(this.referenceMessageObj) != '{}'){
        sendMessage.messageReference = {
          hasRevoked: this.referenceMessageObj.hasRevoked !== null ? this.referenceMessageObj.hasRevoked : false,
          refContent: this.referenceMessageObj.content,
          refContentType: this.referenceMessageObj.contentType,
          refFileName: this.referenceMessageObj.fileName,
          refMessageId: this.referenceMessageObj.messageId,
          refSendTime: this.referenceMessageObj.sendTime,
          refSenderId: this.referenceMessageObj.senderId,
          refSenderName: this.referenceMessageObj.senderName,
          refServiceId: this.referenceMessageObj.serviceId,
          serviceId: this.serviceId
        }
      } 
      this.$root.socket.emit('message', sendMessage, (res) => {
        if (res.success) {
          let resObg = {
            messageId: res.data.messageId,
            sendTime: res.data.sendTime,
            status: 0,
            belong: 'visitor'
          }
          let result = { ...sendMessage, ...resObg }
          if (this.$refs.chatBody) {
            if (result.serviceId === this.serviceId) {
              this.$refs.chatBody.push_chatList(result)
              this.$refs.chatBody.handleCloseReferenceBox()
            }
          }
          if (this.$refs.h5ChatBody) {
            if (result.serviceId === this.serviceId) {
              this.$refs.h5ChatBody.push_chatList(result)
              this.$refs.h5ChatBody.handleCloseReferenceBox()
            }
          }
        }
      })
    },
    // 发送消息推送socket
    async sendSocketMessage (message) {
      if (this.groupStatus === '1') { //会话中
        this.$store.commit('set_visitorStatus', true)
        this.socketMessageEd(message)
      } else if (this.groupStatus === '2') {
        // 未被客服接待，记录离线消息
        this.recordOffLineMessage(message, true)
      } else {
        if (this.noSendMessageObj[this.groupId]) {
          this.noSendMessageObj[this.groupId] = message
        } else {
          this.$set(this.noSendMessageObj, this.groupId, message)
        }
        // 未被客服接待，记录离线消息
        await this.recordOffLineMessage(message)
        console.log('==========')
        let length = this.channelGroupVoList.length
        // 转接会话
        if ((length > 1 && this.visitorInfo.groupId && this.isEndChat)) {
          this.transferLabor()
        }
        if (length <= 1) {
          this.transferArtifical()
        }
      }
    },
    transferArtifical () {
      const params = {
        visitor: {
          visitorId: this.visitorInfo.visitorId,
          visitorName: this.visitorInfo.visitorName
        },
        request: {
          tenantId: this.visitorInfo.tenantId,
          groupId: this.visitorInfo.groupId,
          groupName: this.visitorInfo.groupName,
          targetAgentId: this.targetAgentId || ''
        },
        source: {
          platformId: 'self',
          platformName: 'self',
          tenantId: this.visitorInfo.tenantId,
          tenantName: this.visitorInfo.tenantName,
          typeId: this.visitorInfo.typeId, // 大渠道
          typeName: this.visitorInfo.typeName,
          channelCode: this.visitorInfo.channelCode, // 小渠道
          channelName: this.visitorInfo.channelName
        },
        features: {
          ip: '',
          region: '',
          terminal: '',
          os: '',
          accessProxy: '',
          language: this.config.language === 'zh' ? 0 : 1
        },
        authInfo: {
          id: '',
          account: '',
          name: '',
          test: ''
        },
        directConnect: this.directConnect || false
      }
      this.$root.socket.emit('request', params, (res) => {})
    },
    recordOffLineMessage (message, isBusy) {
      let channelGroupVoList = this.channelGroupVoList
      if (!this.$store.state.visitorStatus || isBusy) {
        // 发送离线消息
        const params = {
          visitorId: this.visitorInfo.visitorId || localStorage.getItem('newVisitorId') || '',
          content: message.content || '',
          contentType: message.contentType,
          fileName: message.fileName || '',
          fileSuffix: message.fileSuffix || ''
        }
        let content = {
          belong: 'visitor',
          ...message,
          ...params
        }
        return new Promise((resolve) => {
          this.$root.socket.emit('recordOfflineMsg', params, res => {
            console.log(res, '发送离线消息结果')
            this.$bus.$emit('socket.message', {
              sendTime: res.receiveTime,
              ...content
            })
            // isEndChat  如果已经结束会话则继续提示选择技能组  否则不显示技能组
            // 排队的时候不会再显示技能组
            if (channelGroupVoList.length > 1 && !isBusy) {
              this.$store.commit('set_isEndChat', false)
              this.$bus.$emit('socket.message', { channelGroupVoList: channelGroupVoList })
            }
            resolve()
          })
        })
      }
    },
    // 预览消息推送socket
    previewSocketMessage (message) {
      let sendMessage = message
      this.$root.socket.emit('preview', sendMessage, (res) => {})
    },
    msgCommon () {
      return {
        tenantId: this.visitorInfo.tenantId,
        serviceId: this.serviceId,
        groupId: this.visitorInfo.groupId,
        groupName: this.visitorInfo.groupName,
        source: this.service.channel,
        senderId: this.visitorInfo.visitorId,
        senderName: this.visitorInfo.visitorName,
        receiverId: this.service.agentId,
        receiverName: this.service.agentName,
      }
    },
    // 发送文本消息
    sendTextMessage (message) {
      let msg = {
        ...this.msgCommon(),
        contentType: 'text',
        content: FaceObjConfig.codeFace(message)
      }
      this.sendSocketMessage(msg)
    },
    // 预览本消息
    previewTextMessage (message) {
      let msg = {
        ...this.msgCommon(),
        contentType: 'text',
        content: FaceObjConfig.codeFace(message)
      }
      this.previewSocketMessage(msg)
    },
    contentTypeFile (v) {
      let type = v.split('/')[0]
      if (type === 'image') {
        return 'image'
      } else if (type === 'audio') {
        return 'voice'
      } else if (type === 'video') {
        return 'video'
      } else {
        return 'document'
      }
    },
    // 发送文件
    sendMediaMessage (res) {
      let msg = {
        ...this.msgCommon(),
        contentType: this.contentTypeFile(res.contentType),
        content: res.url,
        fileName: res.fileName
      }
      this.sendSocketMessage(msg)
    },
    readVisitorMsg (readList) {
      let sendMessage = {
        agentId: this.agentId,
        serviceId: this.serviceId,
        tenantId: this.visitorInfo.tenantId,
        visitorId: this.visitorInfo.visitorId,
        messageIds: readList
      }
      this.$root.socket.emit('visitorHasRead', sendMessage, (res) => {

      })
    }
  }
}
